import { combineReducers, compose } from '@reduxjs/toolkit';

import slice from './promo_code.slice';

/** Represents the slice as it exists in the final store's reducer */
const combined = combineReducers({ [slice.name]: slice.reducer });
type GlobalState = ReturnType<typeof combined>;

/** Get the local state for the current domain */
const localState = (state: GlobalState) => state[slice.name];
type LocalState = ReturnType<typeof localState>;

export const selectPromoStatus = (state: LocalState) => state.status;
export const selectValidPromoCode = (state: LocalState) => state.valid;
export const selectPromoError = (state: LocalState) => state.message;

export default {
  status: compose(selectPromoStatus, localState),
  valid: compose(selectValidPromoCode, localState),
  error: compose(selectPromoError, localState),
};
